<template>
  <div class="item-unit-modal">
    <form action="" @submit.prevent="submitBulkProcessData">
      <div class="card-body">
        <div class="form-group row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">{{ $t('prepayments.rate_of_pre_payment') }}</label><span class="text-danger"> *</span>
              <div class="base-input">
                <money
                  :class="{'invalid' : $v.formData.rate_prepayment.$error}"
                  v-model="formData.rate_prepayment"
                  v-bind="percentageFormatMoneyComponent"
                  class="input-field"
                />
              </div>
              <div v-if="$v.formData.rate_prepayment.$error">
                <span v-if="!$v.formData.rate_prepayment.between" class="form-group__message text-danger">{{ $t('validation.enter_valid_tax_rate') }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-6 base-input">
            <label class="form-label">{{ $t('general.financing_ratio') }}</label><span class="text-danger"> *</span>
            <!--              <base-input-->
            <!--                  :invalid="$v.formData.financing_ratio.$error"-->
            <!--                  v-model="formData.financing_ratio"-->
            <!--                  type="number"-->
            <!--                  name="financing_ratio"-->
            <!--                  tab-index="1"-->
            <!--                  @input="$v.formData.financing_ratio.$touch()"-->
            <!--              />-->
            <money
              :class="{'invalid' : $v.formData.financing_ratio.$error}"
              v-model="formData.financing_ratio"
              v-bind="percentageFormatMoneyComponent"
              class="input-field"
            />

            <base-input
              v-model="formData.invoice_ids"
              type="hidden"
              name="invoice_ids"
              tab-index="1"
              @input="$v.formData.invoice_ids.$touch()"
            />
            <div v-if="$v.formData.financing_ratio.$error">
              <span v-if="!$v.formData.financing_ratio.required" class="text-danger">
                {{ $tc('validation.required') }}
              </span>
              <span v-if="!$v.formData.financing_ratio.between" class="form-group__message text-danger">{{ $t('validation.enter_valid_tax_rate') }}</span>

            </div>
          </div>

        </div>
      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeBulkProcessModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
        <base-button
          :loading="isLoading"
          color="theme"
          icon="save"
          type="submit"
        >
          Process
        </base-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required, between } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],

  data () {
    return {
      isEdit: false,
      isLoading: false,
      formData: {
        invoice_ids: null,
        rate_prepayment: 0.00,
        financing_ratio: 0.00
      },
      percentageFormatMoneyComponent: {
        decimal: '.',
        thousands: ',',
        prefix: '% ',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    ...mapGetters('invoice', [
      'selectedInvoices'
    ]),
    ...mapGetters('modal', [
      'modalData'
    ]),
    ...mapGetters('preapprovedinvoice', [
      'selectedSupplierCompany'
    ])
  },
  created () {
  },
  validations: {
    formData: {
      rate_prepayment: {
        between: between(0, 100)
      },
      financing_ratio: {
        required,
        between: between(0, 100)
      }
    }
  },
  async mounted () {
    this.formData.invoice_ids = this.selectedInvoices.join(',')
    var data = {
      company_id: localStorage.getItem('selectedCompany'),
      guest_company_id: this.selectedSupplierCompany
    }
    let response = await this.getImpact(data)
    if (response.data && response.data.margin_rate) {
      this.formData.financing_ratio = response.data.margin_rate
    }
    if (response.data && response.data.rate_of_prepayment) {
      this.formData.rate_prepayment = Number(response.data.rate_of_prepayment)
    }
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'setIsSearching',
      'resetModalData'
    ]),

    ...mapActions('preapprovedinvoice', [
      'bulkProcessFunderInvoices'
    ]),

    ...mapActions('companyImpactOthers', [
      'getImpact'
    ]),
    resetFormData () {
      this.formData = {
        rate_prepayment: null,
        financing_ratio: null
      }
      this.$v.formData.$reset()
    },
    async submitBulkProcessData () {
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }

      let response
      this.setIsSearching()
      response = await this.bulkProcessFunderInvoices(this.formData)
      this.setIsSearching()
      if (response.data.success === true) {
        this.isLoading = false
        window.toastr['success']('Invoices bulk processed successfully')
        this.closeBulkProcessModal()
        location.reload()
        return true
      }
      this.closeBulkProcessModal()
      window.toastr['error']('something went wrong')
    },

    closeBulkProcessModal () {
      this.resetModalData()
      this.resetFormData()
      this.closeModal()
    }
  }
}
</script>
